/* eslint-disable */
import $ from 'jquery';
import React from 'react';
import { connect } from 'react-redux';
import Menu from './Menu';
import CommonClass from '../../js/common';
import {
	HOME_PAGE_UNLOADED
} from '../../constants/actionTypes';

const mapStateToProps = state => ({
	...state.home,
	appName: state.common.appName,
	token: state.common.token
});

const mapDispatchToProps = dispatch => ({
	onUnload: () =>
		dispatch({ type: HOME_PAGE_UNLOADED })
});

class ContactUS extends React.Component {
	componentWillMount() {

	}
	componentDidMount() {
		var CONTAINER_ORIGINAL_WIDTH = $('#MainContainer').css('width');
		var CONTAINER_ORIGINAL_HEIGHT = $('#MainContainer').css('height');

		var CONTAINER1_ORIGINAL_WIDTH = $(window).width();
		var CONTAINER1_ORIGINAL_HEIGHT = $(window).height();

		var mobileHightAdj = 50;
		var mobileWidthAdj = 50;

		var resizePadding = 1;
		var mousehover = 0;

		var isPortrait = false;
		var isMobile = false;

		if (window.matchMedia("(orientation: portrait)").matches) {
			// you're in PORTRAIT mode
			isPortrait = true;
		}

		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
			.test(navigator.userAgent)) {
			mousehover = 1;
			isMobile = true;
		} else {
			if (isPortrait == true) {
				$("#portrait-blocker").hide();
			}
		}
		// if (isMobile == false) {
		$("#MainContainer").css('width', CONTAINER_ORIGINAL_WIDTH);
		$("#MainContainer").css('height', CONTAINER_ORIGINAL_HEIGHT);

		var screen = {
			left: 0,
			top: 0,
			width: 0,
			height: 0
		};

		screen.width = window.innerWidth;
		screen.height = window.innerHeight;
		var scaleTo = 1;

		screenresize(true);;

		$(window).resize(function () {
			screenresize(true);;
		});

		function screenresize(isonload) {
			var width = $(window).width();
			var height = $(window).height();

			var maxWidth = window.screen.width;
			var maxHeight = window.screen.height;

			if (resizePadding == 1) {
				maxHeight = maxHeight + (mobileHightAdj);
				maxWidth = maxWidth + (mobileWidthAdj);
			}

			var scaleTo;

			if (width >= maxWidth && height >= maxHeight) {
				scaleTo = 1;
			} else {
				scaleTo = Math.min(width / maxWidth, height / maxHeight);
			}
			// $('#MainContainer').css({ "transform": "scale(" + scaleTo + ")" });

			var containerLeft = 0;
			if ($(window).width() < parseInt(CONTAINER_ORIGINAL_WIDTH.replace("px", ""))) {
				containerLeft = - (parseInt(CONTAINER_ORIGINAL_WIDTH.replace("px", "")) - $(window).width()) / 2;
			}
			$('#MainContainer').css('left', containerLeft);

			var containerTop = (height - (maxHeight * scaleTo)) / 2;

			if ($('.content-container').hasClass('active') == true) {
				$("#MainContainer").css('width', CONTAINER1_ORIGINAL_WIDTH);
				$("#MainContainer").css('height', CONTAINER1_ORIGINAL_HEIGHT);
			}
		}

	}
	componentWillUnmount() {
		this.props.onUnload();
	}
	render() {
		return (
			<div className="content-resize-container" id="MainContainer">
				<Menu />
				<div className="main">
					<div className="main-content" id="contactUs-content">
						<img className="rn content-ring" src={CommonClass.cdn_url + "images/ContentRing.svg"} />
						<div className="apData contact-us__hldr">
							<h2 className='contact__us'>contact us</h2>
							<p className='location'>6101 Bollinger Canyon Rd #343, San Ramon, CA 94583, USA</p>
							<div className="contactDataWrap">
								<p className="tel"><img src={CommonClass.cdn_url + "images/call.svg"} />+1 510-656-5943</p>
								<p className="emailId"><a className="mailto" href="mailto:aspire@aspiricx.com" title="aspire@aspiricx.com"><img src={CommonClass.cdn_url + "images/email.svg"} />aspire@aspiricx.com</a></p>
								<div className="socialMediaWrap">
									<a className="facebook" href="https://www.facebook.com/aspiricx/" title="aspiricx | Facebook" target="_blank"><img src={CommonClass.cdn_url + "images/facebook.svg"} /></a>
									<a className="twitter" href="https://twitter.com/aspiricx" title="aspiricx | Twitter" target="_blank"><img src={CommonClass.cdn_url + "images/twitter.svg"} /></a>
									<a className="linkedin" href="https://in.linkedin.com/company/aspiricx" title="aspiricx | LinkedIn" target="_blank"><img src={CommonClass.cdn_url + "images/linkedin.svg"} /></a>
									<a className="instagram" href="https://www.instagram.com/aspiricx" title="aspiricx | Instagram" target="_blank"><img src={CommonClass.cdn_url + "images/instagram.svg"} /></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactUS);




// WEBPACK FOOTER //
// src/components/Home/Contactus.js